export const MODULE_QUICK_CHIP_KEYS = {
  facturation: ['create_document', 'clients', 'reminders', 'analytics'],
  inventaire: ['stock_alerts', 'movements', 'warehouses', 'replenishment'],
  achats: ['requests', 'orders', 'receipts', 'suppliers'],
  ventes: ['orders', 'pipeline', 'deliveries', 'forecasts'],
  rh: ['leave', 'employees', 'recruitment', 'training'],
  pointage: ['absences', 'delays', 'attendance', 'leave'],
  salaires: ['payroll_validation', 'journal', 'transfers', 'cnas'],
  situation: ['incidents', 'crises', 'plans', 'summary'],
  caisse: ['closures', 'journal', 'vouchers', 'reconciliation'],
  banque: ['reconciliation', 'accounts', 'checks', 'transfers'],
  comptabilite: ['closing', 'entries', 'balance', 'ledger'],
  tresorerie: ['liquidity', 'position', 'flows', 'investments'],
  budget: ['variances', 'workflow', 'commitments', 'tracking'],
  projets: ['milestones', 'tasks', 'risks', 'resources'],
  contrats: ['deadlines', 'approvals', 'renewals', 'clients'],
  production: ['orders', 'breakdowns', 'quality', 'planning'],
  maintenance: ['tickets', 'emergencies', 'planning', 'equipment'],
  qualite: ['nc', 'audits', 'actions', 'indicators'],
  import_export: ['declarations', 'inspections', 'shipments', 'logistics'],
  parc_auto: ['repairs', 'insurance', 'vehicles', 'fuel'],
  logistique: ['incidents', 'parcels', 'routes', 'delays'],
  distribution: ['routes_daily', 'planning', 'preparation', 'routes'],
  livraison: ['in_progress', 'refused', 'proofs', 'tracking'],
  point_de_vente: ['pos_stock', 'cash', 'sales', 'inventory'],
  marketing: ['campaigns', 'roi', 'budget', 'events'],
  crm: ['leads', 'pipeline', 'tickets', 'opportunities'],
  service_client: ['sla_tickets', 'requests', 'complaints', 'sla'],
  taches: ['urgent', 'my_tasks', 'kanban', 'reminders'],
  approbations: ['my_approvals', 'workflows', 'statuses', 'history'],
  planification: ['appointments', 'reminders', 'calendar', 'workload'],
};
